define(function(require) {
  const IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
	url: function(){
	  if (this.switchingToOrganization) {
		return '/delegate/civics-api/api/portal/switch-profile/organizations/'+ this.id + '/token';
	  } else {
		  return '/delegate/civics-api/api/portal/switch-profile/users/token';
	  }
	},
	parse: function (response) {
			return response;
		}
  });
});
